<template>
  <div class="section2-container">
    <!-- <div class="container"> -->
    <div class="box">
      <div class="row m-0 icon-container">
        <div class="col-12 col-lg-4 wrapper">
          <div class="">
            <div class="icon">
              <div class="circle">
                <img src="@images/icon1.png" />
              </div>
            </div>
            <div class="text">
              <h2>{{ $t("message.section2.title[0]") }}</h2>
              <span>
                {{ $t("message.section2.text[0]") }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 wrapper">
          <div class="">
            <div class="icon">
              <div class="circle">
                <img src="@images/icon3.png" />
              </div>
            </div>
            <div class="text">
              <h2>{{ $t("message.section2.title[1]") }}</h2>
              <span>
                {{ $t("message.section2.text[1]") }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 wrapper">
          <div class="">
            <div class="icon">
              <div class="circle">
                <img src="@images/icon2.png" />
              </div>
            </div>
            <div class="text">
              <h2>{{ $t("message.section2.title[2]") }}</h2>
              <span>
                {{ $t("message.section2.text[2]") }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "section2"
};
</script>

<style lang="scss" scoped>
@import "@scss/home/section2.scss";
</style>